export var DB;
(function (DB) {
    let DBTable;
    (function (DBTable) {
        DBTable["SCHEMA"] = "schema";
        DBTable["FUNCTION_NODE"] = "functionNode";
        DBTable["FORM_GRID_SETTING"] = "formGridSetting";
        DBTable["VIEW_PERSONALIZATION"] = "viewPersonalization";
    })(DBTable = DB.DBTable || (DB.DBTable = {}));
    let DBField;
    (function (DBField) {
        DBField["ID"] = "id";
        DBField["TIMESTAMP"] = "timestamp";
        DBField["VALUE"] = "value";
    })(DBField = DB.DBField || (DB.DBField = {}));
    let DBFormGridSettingKeys;
    (function (DBFormGridSettingKeys) {
        /** 翻页信息 currentPage/pageSize */
        DBFormGridSettingKeys["PAGE"] = "page";
        /** 排序信息 order/field */
        DBFormGridSettingKeys["SORT"] = "sort";
        /** 列宽 */
        DBFormGridSettingKeys["COLUMN_WIDTH"] = "columnWidth";
    })(DBFormGridSettingKeys = DB.DBFormGridSettingKeys || (DB.DBFormGridSettingKeys = {}));
    let DBViewPersonalizationKeys;
    (function (DBViewPersonalizationKeys) {
        /** flag */
        DBViewPersonalizationKeys["IS_NEW"] = "isNew";
        /** 子表编码 */
        DBViewPersonalizationKeys["GRID_SCHEMA_CODE"] = "gridSchemaCode";
        /** 配置列编码 */
        DBViewPersonalizationKeys["CONFIGURABLE_COLUMN_CODES"] = "configurableColumnCodes";
        /** 显示列编码 */
        DBViewPersonalizationKeys["DISPLAY_COLUMN_CODES"] = "displayColumnCodes";
        /** 泳道显示列编码 */
        DBViewPersonalizationKeys["LINE_DISPLAY_COLUMN_CODES"] = "lineDisplayColumnCodes";
        /** 列表固定列 */
        DBViewPersonalizationKeys["FIXED_COLUMNS"] = "fixedColumns";
        /** 列表列宽 */
        DBViewPersonalizationKeys["COLUMNS_WIDTH"] = "columnsWidth";
        /** 列表排序信息 order/field */
        DBViewPersonalizationKeys["SORT"] = "sort";
        /** 排序规则 */
        DBViewPersonalizationKeys["SORT_RULES"] = "sortRules";
        /** 翻页信息 */
        DBViewPersonalizationKeys["PAGE"] = "page";
        /** 筛选显示状态 */
        DBViewPersonalizationKeys["FILTER_VISIBLE"] = "filterVisible";
        /** 筛选固定状态 */
        DBViewPersonalizationKeys["FILTER_FIXED"] = "filterFixed";
        /** 个性化(筛选条件组) */
        DBViewPersonalizationKeys["VIEW_PREFERENCE"] = "viewPreference";
        /** 分组筛选展开状态 */
        DBViewPersonalizationKeys["GROUP_COLLAPSED"] = "groupCollapsed";
        /** 分组筛选包含下级状态 */
        DBViewPersonalizationKeys["GROUP_IS_CONTAIN"] = "groupIsContain";
        /** 分组筛选仅显示有数据的选项 */
        DBViewPersonalizationKeys["GROUP_IS_ONLY_DATA"] = "groupIsOnlyData";
        /** 列表行高 */
        DBViewPersonalizationKeys["ROW_HEIGHT"] = "rowHeight";
        /** 看板展开与收起 */
        DBViewPersonalizationKeys["KANBAN_BOARD_COLLAPSED"] = "kanbanBoardCollapsed";
        /** 看板泳道现隐藏与排序 */
        DBViewPersonalizationKeys["KANBAN_BOARD_CONFIG"] = "kanbanBoardCONFIG";
        /** 看板视图选中的key */
        DBViewPersonalizationKeys["KANBAN_GROUP_KEY"] = "kanbanGroupKey";
        DBViewPersonalizationKeys["KANBAN_HIDDEN_EMPTY_BOARD"] = "kanbanHIDDENEmptyBoard";
        /** 序号显示方式 */
        DBViewPersonalizationKeys["INDEX_DISPLAY_TYPE"] = "indexDisplayType";
    })(DBViewPersonalizationKeys = DB.DBViewPersonalizationKeys || (DB.DBViewPersonalizationKeys = {}));
})(DB || (DB = {}));
